import React from "react";

const ProcessStepGroup = ({ partNumber, steps, activeIndex, onStepClick }) => {
  return (
    <div className="flex items-center">
      <div className="pb-5">
        <div className="w-[100px] h-[100px] bg-gray-100 rounded-full shadow-lg flex justify-center items-center">
          <span>PART {partNumber}</span>
        </div>
      </div>
                                    
      {steps.map((step, i) => {
        return (
          <div 
            key={i}  
            className="space-y-4 cursor-pointer"
            onClick={() => onStepClick(step.index)}
          >
            <div className="text-center">
              <span className="text-rose-600 text-sm font-bold">{step.gubun}</span>
            </div>
            
            <div className="flex items-center">
              <span className="inline-block w-[180px] h-[2px] bg-gray-200 flex items-center justify-center relative">
                <i className={`absolute inset-0 m-auto block w-[13px] h-[13px] rounded-full
                               ${activeIndex >= step.index ? 'bg-rose-500' : 'bg-gray-200'}`}></i>
                <i className={`absolute inline-block w-[13px] h-[13px] rounded-full z-20
                               ${activeIndex === step.index ? 'animate-ping w-[20px] h-[20px] bg-rose-500' : ''}`}>
                </i>
              </span>
            </div>
            
            <div className="text-center">{step.name}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ProcessStepGroup; 